///<reference path="../../lib/app.d.ts"/>

import logging from "../utils/log";

export class NextRoomLayer
{
	onReady: Function;
	private TAG = "[Sxc.Chat.NextRoomTimer]";

	private canvas : HTMLCanvasElement;
	private ctx : CanvasRenderingContext2D;

	private CIRCLE_SIZE = 120;
	private CIRCLE_ROUNDTIME = 10000;
	private CIRCLE_STROKEWIDTH = 5;

	/** If this flag is set, the loop will break */
	private cancelled : boolean = false;
	private circleColor: string;

	constructor(private $container : JQuery)
	{
		this.canvas = <HTMLCanvasElement> this.$container.find("canvas")[0];
		this.ctx = this.canvas.getContext("2d");
		this.canvas.width = this.canvas.height = this.CIRCLE_SIZE;

		this.$container.find(".spinner").click(() => {
			this.cancel();
			this.onReady();
		})
	}

	doCircle(onReady : Function)
	{
		let startAngle = -0.5 * Math.PI;
		let start = Date.now();
		let center = this.CIRCLE_SIZE / 2;
		let radius = center - this.CIRCLE_STROKEWIDTH / 2;

		let draw = () =>
		{
			this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.cancelled) return;

			let elapsed = Date.now() - start;
			let currAngle = 2 * Math.PI / this.CIRCLE_ROUNDTIME * elapsed;

			this.ctx.beginPath();
			this.ctx.arc(center, center, radius ,startAngle, startAngle + currAngle);
			this.ctx.lineWidth = this.CIRCLE_STROKEWIDTH;
			this.ctx.strokeStyle = this.circleColor;
			this.ctx.stroke();

			if (elapsed <= this.CIRCLE_ROUNDTIME) {
				requestAnimationFrame(draw);
			} else {
				logging.log(this.TAG, "onReady", onReady);
				if (onReady) onReady();
				onReady = null;
			}
		};

		draw();
	}

	start(params : any)
	{
		const id = params.id;
		const screenName = params.screenName;
		const prevScreenName = params.prevScreenName;
		const pic = params.pic;
		const isPom = params.isPom;
		const onReady = params.onReady;

		logging.log(this.TAG, "[start]", params);

		this.cancelled = false;
		this.onReady = onReady;

		this.$container.find(".screenname-old").text(prevScreenName);

		this.$container.addClass("sxc-visible");

		if (isPom) {
			this.$container.addClass(".sxccw-special-pom");
			this.$container.find(".sxccw-performer-next").hide();
			this.$container.find(".sxccw-performer-next-pom").show();
			this.circleColor="#ffdd65";
		} else {
			this.$container.removeClass(".sxccw-special-pom");
			this.$container.find(".sxccw-performer-next").show();
			this.$container.find(".sxccw-performer-next-pom").hide();
			this.circleColor="#fff";
		}

		this.$container.find(".sxccw-part-1").show();
		this.$container.find(".sxccw-part-2").hide();
		this.$container.find(".sxccw-part-idle").hide();

		let phase2 = () => {
			if (this.cancelled) return;
			this.$container.find(".sxccw-part-idle").hide();
			this.$container.find(".sxccw-part-1").hide();
			this.$container.find(".sxccw-part-2").show();

			this.$container.find(".screenname").text(screenName);
			this.$container.find(".image").css("background-image", "url(" + pic + ")");

			this.doCircle(onReady);
		};

		let timer = setTimeout(phase2, 3000);
	}

	cancel():void
	{
		logging.log(this.TAG, "[cancel]");

		this.$container.removeClass("sxc-visible");
		this.$container.find(".sxccw-part-1").hide();
		this.$container.find(".sxccw-part-2").hide();

		this.cancelled = true;

	}

	idle(screenName : string) : void {
		this.$container.addClass("sxc-visible");
		this.$container.find(".sxccw-part-1").hide();
		this.$container.find(".sxccw-part-2").hide();
		this.$container.find(".sxccw-part-idle").show();
		this.$container.find(".screenname-old").text(screenName);
	}
}
